import left from './left.png';
import right from './right.png';
import down from './down.png';
import up from './forward.png';
import center from './center.png';

export {left,right,down,up,center};
